import { useQuery } from '@tanstack/react-query';
import { UserDetailService } from '../services/userDetail.service';

export function useUserDetail(id?: string) {
 return useQuery({
 queryKey: ['users-detail', id],
 queryFn: () => UserDetailService.getUserDetail(id!),
 enabled: !!id,
 meta: {
 errorMessage: 'Lỗi tải hồ sơ nhân sự'
 }
 });
}
